import React from 'react';
import { Box, TextField, Checkbox, FormControlLabel, MenuItem } from '@mui/material';

export default function SchemaRenderer({ schema, value, onChange, disabled }) {
  if (!schema || schema.type !== 'object') return null;
  const v = value || {};

  const handleChange = (key, val) => {
    onChange && onChange({ ...v, [key]: val });
  };

  const fields = schema.properties || {};
  return (
    <Box sx={{ display: 'grid', gap: 2 }}>
      {Object.entries(fields).map(([key, def]) => {
        const title = def.title || key;
        const required = (schema.required || []).includes(key);
        const type = def.type;
        const val = v[key] ?? '';

        if (type === 'boolean') {
          return (
            <FormControlLabel
              key={key}
              control={<Checkbox checked={!!val} onChange={(e) => handleChange(key, e.target.checked)} disabled={disabled} />}
              label={title}
            />
          );
        }

        // Select enum
        if (Array.isArray(def.enum)) {
          return (
            <TextField
              key={key}
              select
              label={title}
              value={val}
              onChange={(e) => handleChange(key, e.target.value)}
              required={required}
              disabled={disabled}
              size="small"
            >
              {def.enum.map((opt) => (
                <MenuItem key={String(opt)} value={opt}>{String(opt)}</MenuItem>
              ))}
            </TextField>
          );
        }

        let inputType = 'text';
        if (def.format === 'date') inputType = 'date';
        if (type === 'number' || type === 'integer') inputType = 'number';

        return (
          <TextField
            key={key}
            label={title}
            value={val}
            onChange={(e) => handleChange(key, e.target.value)}
            required={required}
            disabled={disabled}
            type={inputType}
            size="small"
            InputLabelProps={inputType === 'date' ? { shrink: true } : undefined}
          />
        );
      })}
    </Box>
  );
}

